import { aiDashboardAssets } from './constants';
import { lastTransitionDate } from '../../_shared/utils/last-transition-date';

const settings = {
  pending: true,
  error: false,
  loaded: false,
};

export const defaultAiDashboardSlice = {
  [aiDashboardAssets.apps]: {
    data: [],
    settings,
  },
  [aiDashboardAssets.marketOverview]: {
    data: {},
    settings,
  },
  [aiDashboardAssets.timeSpentPenetration]: {
    data: {},
    settings,
    filters: {
      change_type: 'year_over_year',
    },
  },
  [aiDashboardAssets.timeSpentPenetrationIndex]: {
    data: {},
    settings,
  },
  [aiDashboardAssets.usageTrends]: {
    data: {},
    settings,
  },
  [aiDashboardAssets.usageTransitions]: {
    data: {},
    settings,
    filters: {
      month_date: lastTransitionDate,
    },
  },
  [aiDashboardAssets.segmentConcentration]: {
    data: {},
    settings,
  },
  [aiDashboardAssets.sectorsStats]: {
    data: {},
    settings,
    filters: {
      change_type: 'year_over_year',
    },
  },
  [aiDashboardAssets.aiAppTrends]: {
    data: {},
    settings,
    filters: {
      app_uid: null,
    },
  },
  [aiDashboardAssets.segmentTransitions]: {
    data: {},
    settings,
    filters: {
      app_uid: null,
      month_date: lastTransitionDate,
    },
  },
  [aiDashboardAssets.aiAppImpact]: {
    data: {},
    settings,
    filters: {
      granularity: 'monthly',
      app_uid: null,
      app: null,
    },
  },
  [aiDashboardAssets.financeApps]: {
    data: {},
    settings,
    filters: {
      query: '',
      limit: 20,
      offset: 0,
    },
  },
};
